import { render, staticRenderFns } from "./IncidentDetail.vue?vue&type=template&id=34b44c32&scoped=true&"
import script from "./IncidentDetail.vue?vue&type=script&lang=ts&"
export * from "./IncidentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./IncidentDetail.vue?vue&type=style&index=0&id=34b44c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b44c32",
  null
  
)

export default component.exports